import { jwtDecode } from "jwt-decode";
import { DecodedToken } from "./DecodedToken";
import { claimValueAsString } from "./claimValueAsString";

export const getUserInfoFromToken = (
  token: string
): DecodedToken | null => {
  if (!token) return null;

  try {
    const decoded: DecodedToken = jwtDecode(token);
    return {
      email: claimValueAsString(
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] ||
        decoded.email
      ),
      role:
        decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ||
        decoded.role,
      name: claimValueAsString(
        decoded.unique_name ||
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
        decoded.name
      ),
      instructorId: claimValueAsString(decoded.InstructorId || decoded.instructorId),
      organizationId: claimValueAsString(decoded.OrganizationId || decoded.organizationId),
      organizationRole: claimValueAsString(
        decoded.OrganizationRole || decoded.organizationRole
      ),
    };
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};
